function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.55 162.97l-49.21-49.21c5.37-9.89 8.42-21.22 8.42-33.24 0-38.57-31.38-69.95-69.95-69.95S8.84 41.95 8.84 80.52c0 38.57 31.38 69.95 69.95 69.95 13.82 0 26.7-4.04 37.56-10.99l48.34 48.34c1.07 1.07 2.48 1.61 3.89 1.61s2.82-.54 3.89-1.61l17.07-17.07a5.507 5.507 0 0 0 .01-7.78zM19.84 80.52c0-32.51 26.45-58.95 58.95-58.95s58.95 26.45 58.95 58.95c0 32.51-26.45 58.95-58.95 58.95s-58.95-26.45-58.95-58.95zm105.37 52.27c3.28-2.92 6.29-6.14 8.97-9.62l43.69 43.69-9.3 9.3"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.61141d4c.svg";
export { ForwardRef as ReactComponent };